import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChainLink2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChainLink2"><Path fillRule="evenodd" clipRule="evenodd" d="M1 6H9V8H3V16H9V18H1V6ZM15 6H23V18H15V16H21V8H15V6ZM6 11H18V13H6V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChainLink2;
